import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './components/Home';
import About from './components/About';
import Contact from './components/Contact';
import ProductsCategory from './components/ProductsCategory';
import ProductDetail from './components/ProductDetail';
import Quality from './components/Quality';
import Sustainability from './components/Sustainability';
import InquiryForm from './components/InquiryForm';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import './App.css';

function AppContent() {
  const location = useLocation();

  return (
    <div className="app">
      <ScrollToTop />
      <Navbar />
      <main className="main-content">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/products/:category" element={<ProductsCategory />} />
          <Route path="/products/:category/:productId" element={<ProductDetail />} />
          <Route path="/quality" element={<Quality />} />
          <Route path="/sustainability" element={<Sustainability />} />
        </Routes>
      </main>
      {/* Render InquiryForm on all pages except Home and Contact */}
      {location.pathname !== "/" && location.pathname !== "/contact" && <InquiryForm />}
      <Footer />
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
